export default "/StatisticheIsaWeb/dist/img/macroregioni.svg";